import { SR_FACE_DECISIONS } from "../sr-constants";

export type SrFaceDecision = (typeof SR_FACE_DECISIONS)[number];

export type SrFacePhoto = {
    link?: string;
    s3_link?: string;
    url?: string;
    [key: string]: unknown;
};

export type SrFaceMatch = {
    voterid?: string;
    score?: number;
    same_voterid?: boolean;
    voter?: Record<string, unknown>;
    photos?: SrFacePhoto[];
    latest_photo?: string | SrFacePhoto;
    service_requests?: unknown[];
    [key: string]: unknown;
};

export type SrFaceCheckResult = {
    registered?: boolean;
    captured_photo?: string;
    decisions?: SrFaceDecision[];
    matches?: SrFaceMatch[];
};

export type SrFaceDecisionResult = {
    voter?: Record<string, unknown>;
    photos?: SrFacePhoto[];
    service_requests?: unknown[];
    [key: string]: unknown;
};

export type VoterPhotoUploaded = {
    photoUrl: string;
    decision?: SrFaceDecision;
    matchedVoterId?: string;
    voter?: Record<string, unknown>;
    photos?: SrFacePhoto[];
};

export const getPhotoLink = (photo?: string | SrFacePhoto | null): string => {
    if (!photo) return "";
    if (typeof photo === "string") return photo;
    return String(photo.link || photo.url || photo.s3_link || "");
};
